import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Recibo } from '../recibo.interface';

@Injectable()
export class CropReciboService
{
  imagen = null;

  respuesta = {
    imagen: null,
  };

  esImagen = true;

  private _imagen = new BehaviorSubject<string>('');
  imagen$ = this._imagen.asObservable();

  constructor(private _http: HttpClient) { }

  get recibo()
  {
    return this._imagen.getValue();
  }

  set recibo(value: string)
  {
    this._imagen.next(value);
  }

  createRecibo(recibo: Recibo)
  {
    return this._http.post(`${environment.API_URL}/PagoTransferencia`, recibo);
  }

  createReciboSU(recibo: Recibo)
  {
    return this._http.post(
      `${environment.API_URL}/PagoTransferencia/SignUp`,
      recibo
    );
  }

  validateRecibo(recibo: Recibo)
  {
    return this._http.post<string>(
      `${environment.API_URL}/PagoTransferencia/Validar`,
      recibo
    );
  }

  reset()
  {
    this.recibo = null;
    this.imagen = null;
    this.esImagen = true;
  }
}
